import { validateSlugUniquenessMW } from "pages/ManagementPage/middleware";

const validateSlugUniqueness = async slug => {
  const isSlugUnique = await validateSlugUniquenessMW({ urlParams: [slug] });
  return isSlugUnique;
};

export default validateSlugUniqueness;
